export default {"src":"/_next/static/media/upload-cloud.3e6f787f.svg","height":40,"width":51,"blurWidth":0,"blurHeight":0};